module.exports = __webpack_public_path__ + "img/kerstin_cv_5.974ddc60.jpg";